import { Quote } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { IMG } from "@/data/site";
import { Kicker, Reveal } from "./Reveal";

export const About = () => {
  const { t } = useLang();
  const stats = [
    { v: "2011", l: t.about.stats[0] },
    { v: "7/7", l: t.about.stats[1] },
    { v: "16h", l: t.about.stats[2] },
  ];
  return (
    <section id="palestra" data-testid="about-section" className="relative paper text-ink overflow-hidden">
      {/* ghost year */}
      <span
        aria-hidden="true"
        className="pointer-events-none select-none absolute -right-6 top-6 font-display text-[34vw] lg:text-[22rem] leading-none text-outline-ink opacity-[0.07]"
      >
        2011
      </span>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 grid lg:grid-cols-12 gap-14 lg:gap-10">
        <div className="lg:col-span-7">
          <Reveal>
            <Kicker testid="about-kicker">{t.about.kicker}</Kicker>
            <h2 data-testid="about-title" className="font-display text-5xl sm:text-6xl lg:text-7xl mt-6 leading-[0.9] max-w-[14ch]">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="mt-8 grid sm:grid-cols-2 gap-6 max-w-[64ch]">
            <p className="text-[15px] leading-relaxed text-ink/80">
              {t.about.p1}
            </p>
            <p className="text-[15px] leading-relaxed text-ink/80">{t.about.p2}</p>
          </Reveal>

          <Reveal delay={0.15} className="mt-12 grid grid-cols-3 border-2 border-ink bg-bone shadow-[8px_8px_0_#0F0F10] max-w-xl">
            {stats.map((s, i) => (
              <div key={s.v} className={`p-4 sm:p-5 ${i > 0 ? "border-l-2 border-ink" : ""}`} data-testid={`about-stat-${i}`}>
                <div className="big-num text-5xl sm:text-6xl text-hammer-red">{s.v}</div>
                <div className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-ink/60 mt-2">{s.l}</div>
              </div>
            ))}
          </Reveal>

          <Reveal delay={0.2} className="mt-14 relative max-w-2xl">
            <Quote className="w-10 h-10 text-hammer-red -scale-x-100" />
            <blockquote data-testid="about-quote" className="font-display text-3xl sm:text-4xl leading-[1] mt-3">
              “{t.about.quote}”
            </blockquote>
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-ink/60 mt-3">— {t.about.quoteBy}</p>
          </Reveal>
        </div>

        {/* polaroid */}
        <div className="lg:col-span-5 relative">
          <Reveal y={30} className="relative mx-auto max-w-[420px] lg:mt-10">
            <figure
              className="relative bg-bone p-3 pb-16 border-2 border-ink shadow-[12px_12px_0_#0F0F10] rotate-[2.5deg] hover:rotate-0 transition-transform duration-500"
              data-testid="about-polaroid"
            >
              <span className="tape tape-tl" />
              <span className="tape tape-tr" />
              <div className="relative overflow-hidden aspect-[4/5] bg-ink group">
                <img
                  src={IMG.athlete}
                  alt="Atleta della Hammer Gym in posa davanti all'insegna"
                  loading="lazy"
                  className="w-full h-full object-cover photo-warm group-hover:[filter:none]"
                />
                <div className="tint-red group-hover:opacity-0 transition-opacity duration-500" />
                <div className="grain-layer" />
              </div>
              <figcaption className="absolute bottom-4 left-4 right-4 font-hand text-xl text-ink/85 -rotate-1">
                {t.about.note}
              </figcaption>
            </figure>
            <div className="absolute -top-8 -left-6 sm:-left-10 sticker w-28 h-28 bg-hammer-red text-bone border-2 border-ink rotate-[-14deg] shadow-[5px_5px_0_#0F0F10]">
              <span className="font-display text-2xl leading-[0.85] px-2">
                NO PAIN
                <br />
                NO GAIN
              </span>
            </div>
            <p className="relative mt-8 text-right lg:mt-0 lg:absolute lg:-bottom-12 lg:right-0 font-hand text-hammer-red text-2xl rotate-[4deg]" data-testid="about-prompt">
              {t.about.prompt}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
